// =============================================================================
// services/haptics.ts — tiny haptic-feedback adapter (blueprint §1 swap #12).
//
// MIGRATION: expo-haptics (`impactAsync(ImpactFeedbackStyle.Light|Medium)`) →
// react-native-haptic-feedback (`trigger('impactLight'|'impactMedium')`). Only
// the post-detail screen uses haptics (1 site in the FEED group), so this wraps
// the lib behind a stable `impact('light'|'medium')` API.
//
// The lib is a P3-added native dep (declared in package.json; pod install brings
// it in). It's loaded via a guarded require so this module — and every screen
// that imports it — type-checks and runs even before the pod is installed
// (haptics simply no-op until then). Same pattern the shell uses for deferred
// native libs.
// =============================================================================

type Impact = 'light' | 'medium' | 'heavy';

const TRIGGER: Record<Impact, string> = {
  light: 'impactLight',
  medium: 'impactMedium',
  heavy: 'impactHeavy',
};

let _mod: any = null;
let _tried = false;

function lib(): any {
  if (_tried) return _mod;
  _tried = true;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _mod = require('react-native-haptic-feedback');
    _mod = _mod?.default ?? _mod;
  } catch {
    _mod = null;
  }
  return _mod;
}

/** Fire an impact haptic. Silently no-ops if the native lib isn't present. */
export function impact(style: Impact = 'medium'): void {
  try {
    const m = lib();
    m?.trigger?.(TRIGGER[style], {
      enableVibrateFallback: true,
      ignoreAndroidSystemSettings: false,
    });
  } catch {
    /* non-fatal — haptics are a nicety, never block the action */
  }
}

export default { impact };
